import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import HomePage from "@/pages/HomePage";

/** Dashboard del singolo commerciale: identica alla Home, filtrata sul suo perimetro. */
export default function CommercialeHome() {
  const { slug } = useParams();
  const [nome, setNome] = useState("");

  useEffect(() => {
    api.get("/commerciali").then((r) => {
      const c = (r.data.commerciali || []).find((x) => x.slug === slug);
      setNome(c ? c.nome : slug);
    }).catch(() => setNome(slug));
  }, [slug]);

  return (
    <div data-testid={`commerciale-home-${slug}`}>
      <HomePage slug={slug} titolo={`DASHBOARD LUNGO DBE - ${(nome || slug).toUpperCase()}`} />
    </div>
  );
}
